import { createContext, useContext } from 'react';
import { usePersistedValue } from '../hooks/usePersistedValue';
import { EditorConfigContext } from './EditorConfigContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const EditorUIContext = /*#__PURE__*/createContext({
  showFormattingTray: false,
  setShowFormattingTray: () => {},
  handleFirstClick: undefined
});
EditorUIContext.displayName = 'EditorUIContext';
export function useEditorUIStateManager() {
  const editorConfig = useContext(EditorConfigContext);
  const trayConfig = editorConfig === null || editorConfig === void 0 ? void 0 : editorConfig.FORMATTING_TRAY;

  // Handle both old format (array) and new format (object with shouldPersist)
  // Old format (array) defaults to persist=true
  // New format defaults to persist=true unless explicitly set to false
  const shouldPersist = Array.isArray(trayConfig) ? true : (trayConfig === null || trayConfig === void 0 ? void 0 : trayConfig.shouldPersist) !== false;
  const [showFormattingTray, setShowFormattingTray] = usePersistedValue('showFormattingTray', false, {
    persist: shouldPersist
  });
  return {
    showFormattingTray,
    setShowFormattingTray
  };
}
export function useEditorUIContext() {
  return useContext(EditorUIContext);
}
export function EditorUIProvider(props) {
  const {
    children,
    handleFirstClick
  } = props;
  const {
    showFormattingTray,
    setShowFormattingTray
  } = useEditorUIStateManager();
  return /*#__PURE__*/_jsx(EditorUIContext.Provider, {
    value: {
      showFormattingTray,
      setShowFormattingTray,
      handleFirstClick
    },
    children: children
  });
}